import { render, staticRenderFns } from "./UPEIKspPreLab.vue?vue&type=template&id=fc2af4a8&"
import script from "./UPEIKspPreLab.vue?vue&type=script&lang=js&"
export * from "./UPEIKspPreLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports